import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { StoreDetailsGeneralComponent } from '../store-details-general/store-details-general.component';
import { StoreDetailsTeamDataComponent } from '../store-details-team-data/store-details-team-data.component';
import { StoreDetailsEventDataComponent } from '../store-details-event-data/store-details-event-data.component';
import { StoreDetailsPendingInvitationsDataComponent } from '../store-details-pending-invitations-data/store-details-pending-invitations-data.component';
import { StoreDetailsOrderDataComponent } from '../store-details-order-data/store-details-order-data.component';

@Component({
  selector: 'app-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.scss'],
})
export class StoreDetailsComponent {
  @ViewChild(StoreDetailsGeneralComponent) general_component?: StoreDetailsGeneralComponent;
  @ViewChild(StoreDetailsTeamDataComponent) team_component?: StoreDetailsTeamDataComponent;
  @ViewChild(StoreDetailsEventDataComponent) event_component?: StoreDetailsEventDataComponent;
  @ViewChild(StoreDetailsPendingInvitationsDataComponent)
  pending_invitation_component?: StoreDetailsPendingInvitationsDataComponent;
  @ViewChild(StoreDetailsOrderDataComponent) order_component?: StoreDetailsOrderDataComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.stores);

  store_id: string | null;
  company_id: string | null;

  tabs = this.navigation_service.navigation_set.store_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
    private route: ActivatedRoute,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    this.store_id = this.route.snapshot.paramMap.get('store_id');
    this.company_id = this.route.snapshot.paramMap.get('company_id');
  }

  ngOnInit(): void {
    this.current_tab = this.tabs.get('article');
  }

  onRefresh(): void {
    if (this.current_tab === this.tabs.get('article')) {
      this.general_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('group')) {
      this.team_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('timeline')) {
      this.event_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('mail_outline')) {
      this.pending_invitation_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('receipt_long')) {
      this.order_component?.onRefresh();
    }
  }

  onTabChange(current_tab: string): void {
    this.current_tab = current_tab;
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
